import React from 'react';
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import { wrapper, title as titleStyle, subtitle as subtitleStyle, faqTitle, legalNotice as legalNoticeStyle } from './SingleForm.style';
import { Accordion } from '../Accordion';
export const SingleForm = ({ title, subtitle, faqContent, legalNotice, children }) => {
    return (React.createElement(Box, { sx: wrapper },
        React.createElement(Grid, { container: true, spacing: 5, "data-qa": "single-form-layout-wrapper" },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { sx: titleStyle, "data-qa": "single-form-title" },
                    React.createElement("h1", null, title)),
                React.createElement(Box, { sx: subtitleStyle, "data-qa": "single-form-subtitle" }, subtitle)),
            React.createElement(Grid, { item: true, xs: 12 }, children),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Divider, null)),
            Array.isArray(faqContent) &&
                React.createElement(Grid, { item: true, xs: 12, "data-qa": "single-form-faq" },
                    React.createElement(Box, { sx: faqTitle }, "FAQ"),
                    faqContent.map((item, i) => (React.createElement(Box, { mt: "12px", key: `faq-item-${i}`, "data-qa": `single-form-faq-accordion-${i}` },
                        React.createElement(Accordion, { title: item.questionLabel, isLite: true },
                            React.createElement(Box, { "data-qa": `single-form-faq-accordion-content-${i}` }, item.content)))))),
            legalNotice &&
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Box, { sx: legalNoticeStyle, "data-qa": "single-form-legal" }, legalNotice)))));
};
